export enum MODAL_OVERLAY_TYPE {
  empty = 'empty',
  continue = 'continue',
}

export enum MODAL_CONTINUE_ACTIONS {
  cancel = 'cancel',
  continue = 'continue',
}

export interface ModalContinueActionButton {
  type: MODAL_CONTINUE_ACTIONS;
  title: string;
  class?: string;
}
